import React from "react"
import * as styles from "./footer.module.scss"

import { useSiteQuery, useLocalPath } from "../../../hooks"

import { Link } from "gatsby"
const Footer = () => {
  const { footerMenu } = useSiteQuery()

  return (
    <footer className={styles.footer}>
      <div className={styles.items}>
        {footerMenu.map(({ childrenItems }, index) => (
          <div key={index} className={styles.list}>
            {childrenItems.map(
              ({ title, slug, externalLink, target }, index) => {
                if (target) {
                  return (
                    <div className={styles.item} key={index}>
                      <Link to={useLocalPath(target.slug)}>{title}</Link>
                    </div>
                  )
                } else if (slug) {
                  return (
                    <div className={styles.item} key={index}>
                      <Link to={useLocalPath(slug)}>{title}</Link>
                    </div>
                  )
                } else if (!externalLink) {
                  return (
                    <div className={styles.item} key={index}>
                      <p
                        className={styles.privacyPopupLink}
                        onClick={() => {
                          const w = window as Window & {
                            UC_UI?: { showSecondLayer: () => void }
                          }
                          if (typeof window !== "undefined" && w.UC_UI) {
                            w.UC_UI.showSecondLayer()
                          }
                        }}
                      >
                        Cookieの詳細
                      </p>
                    </div>
                  )
                } else {
                  return (
                    <div className={styles.item} key={index}>
                      <a
                        href={externalLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Link opens in a new window"
                        title="Link opens in a new window"
                      >
                        {title}
                      </a>
                    </div>
                  )
                }
              }
            )}
          </div>
        ))}
      </div>
      <div className={styles.icons}></div>
    </footer>
  )
}

export default Footer
